import Vue from 'vue'
import axios from 'axios'

Vue.prototype.$baseUrl = process.env.VUE_APP_BASE_URL
Vue.prototype.$commonPath = Vue.prototype.$baseUrl + 'engine/public/project/'
Vue.prototype.$axios = axios
Vue.prototype.$isUserLoggedIn = function () {
  return localStorage.getItem(process.env.VUE_APP_LSACCESSTOKENKEY) !== null
}
Vue.prototype.$getUserData = function () {
  if (localStorage.getItem(process.env.VUE_APP_LSUSERDATAKEY)) {
    return JSON.parse(localStorage.getItem(process.env.VUE_APP_LSUSERDATAKEY))
  } else {
    return null
  }
}
Vue.prototype.$userLoggedOut = function () {
  localStorage.removeItem(process.env.VUE_APP_LSUSERDATAKEY)
  localStorage.removeItem(process.env.VUE_APP_LSACCESSTOKENKEY)
  localStorage.removeItem(process.env.VUE_APP_LSREFRESHTOKENKEY)
}
Vue.prototype.$eventBus = new Vue()
Vue.prototype.$refreshDataTable = function () {
  Vue.prototype.$eventBus.$emit('$refreshDataTable')
}
